// eslint-disable-next-line camelcase
const qr_upload = [
	{
		path: 'qr_list',
		name: 'qr.index',
		component: () => import('@/views/qr_list/List.vue'),
		meta: { layout: 'content' },
	},
	{
		path: 'qr/create',
		name: 'qr.create',
		component: () => import('@/views/qr_list/Create.vue'),
		meta: { layout: 'content' },
	},
]

// eslint-disable-next-line camelcase
export default qr_upload
